import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDescomplicaComponent } from './product-descomplica.component';

@NgModule({
  declarations: [
    ProductDescomplicaComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ProductDescomplicaComponent
  ]
})
export class ProductDescomlicaModule { }
